import React, { useState } from 'react';
import { Card, Nav } from 'react-bootstrap';
import { AlertTriangle, Thermometer, CloudRain, Wind, Snowflake } from 'lucide-react';

const VentuskyWeather = ({ lat, lng, resortName }) => {
  const [activeLayer, setActiveLayer] = useState('temperature-2m');

  // Debug logging
  console.log('VentuskyWeather props:', { lat, lng, resortName });

  // Check if coordinates are valid
  if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
    return (
      <Card className="border-0 shadow-sm h-100">
        <Card.Header className="border-0">
          <h5 className="mb-0">Weather Forecast</h5>
        </Card.Header>
        <Card.Body className="p-4 text-center text-muted">
          <div><AlertTriangle size={18} className="me-1" style={{ color: 'var(--pm-rank-gold)' }} /> Weather map unavailable</div>
          <small>Coordinates not available for this resort</small>
          <div className="mt-2 small">
            Lat: {lat || 'N/A'}, Lng: {lng || 'N/A'}
          </div>
        </Card.Body>
      </Card>
    );
  }

  // Weather layer configuration
  const weatherLayers = {
    'temperature-2m': {
      label: 'Temperature',
      icon: <Thermometer size={16} />
    },
    'rain-3h': {
      label: 'Precipitation',
      icon: <CloudRain size={16} />
    },
    'wind-10m': {
      label: 'Wind',
      icon: <Wind size={16} />
    },
    'snow': {
      label: 'Snow Depth',
      icon: <Snowflake size={16} />
    }
  };

  // Generate Ventusky embed URL
  const generateEmbedUrl = (layer) => {
    const encodedResortName = encodeURIComponent(resortName || 'Resort Location');
    const url = `https://embed.ventusky.com/?p=${lat};${lng};8&l=${layer}&pin=${lat};${lng};dot;${encodedResortName}`;
    console.log('Generated Ventusky URL:', url);
    return url;
  };

  return (
    <Card className="border-0 shadow-sm h-100">
      <Card.Header className="border-0">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Weather Forecast</h5>
        </div>
        
        {/* Weather Layer Tabs */}
        <Nav variant="pills" className="mt-3" activeKey={activeLayer}>
          {Object.entries(weatherLayers).map(([layerKey, layerInfo]) => (
            <Nav.Item key={layerKey}>
              <Nav.Link
                eventKey={layerKey}
                onClick={() => setActiveLayer(layerKey)}
                className="me-2 mb-2"
              >
                <span className="me-1">{layerInfo.icon}</span>
                {layerInfo.label}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </Card.Header>
      
      <Card.Body className="p-0">
        {/* Ventusky Embed */}
        <div className="ventusky-embed" style={{
          position: 'relative',
          width: '100%',
          height: '400px',
          margin: 0,
          padding: 0,
          border: 0
        }}>
          <iframe
            key={activeLayer}
            src={generateEmbedUrl(activeLayer)}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              border: 0,
              margin: 0,
              padding: 0
            }}
            loading="lazy"
            title={`${weatherLayers[activeLayer].label} forecast for ${resortName}`}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default VentuskyWeather;